// src/pages/driver/driverJobList/helpers.js — pure helpers for classifying job types into
// card variants and normalizing a job's attached documents. No React state.
import { cardFromCode } from "../../../services/jobTypes";

export const FUTILE_CHARGE_AMOUNT = 180;

export function inferCardFromJobType(jobTypeCode, jobTypeName) {
  const rawCode = String(jobTypeCode || "").trim();
  const rawName = String(jobTypeName || "").trim();

  const direct = String(cardFromCode(rawCode) || "")
    .trim()
    .toLowerCase();
  if (direct) return direct;

  const normalized = `${rawCode} ${rawName}`
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) return "";
  if (normalized.includes("empty")) return "empty";
  if (
    normalized.includes("pick up") ||
    normalized.includes("pickup") ||
    normalized.includes("collect") ||
    normalized.includes("remove")
  ) {
    return "pickup";
  }
  if (normalized.includes("deliver")) return "deliver";

  return "";
}

export function getJobDocuments(job = {}) {
  const documents = Array.isArray(job.jobDocuments)
    ? job.jobDocuments
        .filter((item) => item?.url)
        .map((item, index) => ({
          id: item.id || `document_${index + 1}`,
          url: item.url,
          storagePath: item.storagePath || "",
          name: item.name || `Job document ${index + 1}`,
          contentType: item.contentType || "application/octet-stream",
          mode: item.mode === "view" ? "view" : "sign",
        }))
    : [];

  if (documents.length) return documents;
  if (!job.docketUrl) return [];

  return [
    {
      id: "legacy",
      url: job.docketUrl,
      storagePath: job.docketStoragePath || "",
      name: job.docketFileName || "Delivery docket",
      contentType: job.docketContentType || "application/octet-stream",
      mode: job.docketMode === "view" ? "view" : "sign",
    },
  ];
}
